import { downloadExcelReport, GetYearsFromApi } from 'helpers/downloadExcelReport'
import React, { Children, useEffect, useMemo, useState } from 'react'
import { Button } from "reactstrap"
import Cargando from './Cargando'

export type PropsButtonDownloadReportTable = {
    api: string,
    apiYears: string,
    handleStatus?: (status: number) => void,
    nombreBoton?: string
    onChangeYear?: (anio: number) => Promise<void>,
    yearElegido?: number,
    opcionTodos?:boolean
}


const ComponentButtonExcel = (propsButton: PropsButtonDownloadReportTable) => {

    const [loadingRequest, setloadingRequest] = useState<boolean>(false)
    const [optionsSelect, setoptionsSelect] = useState<number[]>([])
    const [valueSeleccionado,setvalueSeleccionado] = useState<number>(0)

    const classUsandoBoton = "btnEspolAceptar";
    const classUsandoContainerBoton = 'containerButtonExcel'


    async function GetYearsFromSolicitudes() {
        var resultado: number[] = await GetYearsFromApi(propsButton.apiYears);
        setoptionsSelect(resultado);
    }

    async function HandleClickButton(endpoint: string,numberYear:number) {
        setloadingRequest(true);
        var status_action: number = await downloadExcelReport(endpoint, propsButton.nombreBoton,numberYear);
        setloadingRequest(false);
    }


    async function onChangeYear(anio: number) {
        if (typeof (propsButton.onChangeYear) === "function") {
            await propsButton.onChangeYear(anio)
        }
        setvalueSeleccionado(anio);
    }

    useEffect(() => {
        GetYearsFromSolicitudes();
    }, [])

    // useEffect(() => {
    //     if(optionsSelect.length > 0) {
    //         setvalueSeleccionado(optionsSelect[0])
    //     }
    // }, [optionsSelect])


    useEffect(() => {       
        if (propsButton.yearElegido) {
            setvalueSeleccionado(propsButton.yearElegido)
        }
        else if (optionsSelect.length > 0 && propsButton.yearElegido !== 0) {
            setvalueSeleccionado(optionsSelect[0])
        }
    }, [optionsSelect, propsButton.yearElegido])

    

   
       


    const ContainerButton: React.FC = (props) => {
        return (
            <div className={classUsandoContainerBoton}>
                <select onChange={(e) => onChangeYear(+e.target.value)} value={valueSeleccionado}>
                {propsButton.opcionTodos !== undefined && propsButton.opcionTodos === true && <option key={"opcionesYearReportTodos"} value={0} label={"Todos"}/>}

                    {optionsSelect.map((valores, indi) => {
                        return (
                            <option key={"opcionesYearReport" + indi} value={valores} label={valores.toString()} />
                        )
                    })
                    }
                </select>

                {props.children}
            </div>
        )
    }

    const ButtonLoading = () => {
        return (
            <ContainerButton >
                <Button
                    className={classUsandoBoton}
                >
                    Descargando Reporte... <Cargando />
                </Button>
            </ContainerButton>

        )
    }

    const ButtonExcel = (numberYear:number) => {
        return (
            <ContainerButton>
                <Button
                    className={classUsandoBoton}
                    onClick={() => HandleClickButton(propsButton.api,numberYear)}
                >
                    Descargar Reporte
                </Button>
            </ContainerButton>
        )
    }


    return (
        <React.Fragment>
            <div>
                {
                    loadingRequest && optionsSelect.length >0 && ButtonLoading()
                }
                {
                    !loadingRequest && optionsSelect.length >0 && valueSeleccionado >0 && ButtonExcel(valueSeleccionado)
                }
            </div>

        </React.Fragment>

    )



}

const ButtonDownloadReportTable = React.memo(ComponentButtonExcel)

export default ButtonDownloadReportTable    